import { ExperienceItem } from "./experience-item";

export class Role {
	title: string = '';
    experience: Array <ExperienceItem> = new Array <ExperienceItem> ();
}